import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from 'bff/ApiClientProvider';
import {
  PortfolioSummaryViewModel,
  ClientDetailsGetPortfolioSummaryRequest,
  ResultOfPortfolioSummaryViewModel
} from 'bff/client';

export const useInvalidatePortfolioSummary = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: ['portfolioSummary'],
      refetchType: 'all'
    });
};

export const usePortfolioSummaryQuery = (
  request: ClientDetailsGetPortfolioSummaryRequest,
  isEnabled: boolean
): UseQueryResult<PortfolioSummaryViewModel | undefined, Error> => {
  const { clientDetailsApi } = useApiClient();

  const effectiveDateKey =
    request.effectiveDate instanceof Date
      ? request.effectiveDate.toISOString()
      : request.effectiveDate;

  return useQuery<ResultOfPortfolioSummaryViewModel, Error, PortfolioSummaryViewModel | undefined>({
    queryKey: ['portfolioSummary', request.clientId, effectiveDateKey, request.includeAll],
    queryFn: () => clientDetailsApi.clientDetailsGetPortfolioSummary(request),
    select: (response) => response.data,
    enabled: isEnabled && Boolean(request.clientId)
  });
};
